import { Box, Button, Card, CardContent, CardHeader, Container, FormControl, InputLabel, Select, Stack, Tab, Tabs, Typography } from "@mui/material";

import { connect } from "react-redux";
import { MovActions, MovState, RowItensMovDetalhe } from "../../movimentacoes/mov.model";
import { ApplicationState } from "../../../store";
import { bindActionCreators, Dispatch } from "redux";
import { movController } from "../../movimentacoes/mov.controll";
import { formatData, formatMoney } from "../../../services/utils";
import { FiltroReadMovCanal } from "../../canalDist/canalDist.model";
import { GridColDef } from "@mui/x-data-grid";
import { StripedDataGrid } from "../../../components/select";
import { useEffect, useState } from "react";
import Modal from "../../../components/modal";
import { ToolbarModal } from "../../../components/toolbar";
import { a11yProps, TabPanel } from "../../../components/tab";
import EstoqueView, { handleReadEstoque } from "../../estoque/estoque.view";


interface CardResumoProps {
    movState: MovState
    movActions: MovActions
    filtro: FiltroReadMovCanal
}


function getDescAba(value: number): any {
    switch (value) {
        case 0: return "venda-pedidos";
        case 1: return "avaria";
        case 2: return "compras";
    }
}

function CardResumoMov(props: CardResumoProps) {
    const { showModalResumoItens, tabAba } = props.movState

    return (
        <Card variant="outlined" sx={{ p: 0.5, flexShrink: 0 }} >
            <CardContent>
                <Box sx={{ display: "flex", flex: 1, flexDirection: "row", alignItems: "center" }} >
                    <Button variant="contained" color="primary" size="medium" onClick={() => props.movActions.readMovItensPeriodo(props.filtro, getDescAba(tabAba))} >Detalhamento por Itens</Button>

                </Box>

            </CardContent>
            <Modal
                component={<ShellResumoMovItens {...props} />}
                open={showModalResumoItens}
                handleClose={() => props.movActions.setShowModalResumoItens(false)}
                heigth="100%"
                width="lg"
                handleOnKeyDown={() => { }}
            />

        </Card>
    )
}

const getCollumn = (rows: RowItensMovDetalhe): GridColDef[] => {
    return rows.coluna.map((col, idx) => {
        const isOddIndex = idx % 2 === 1;

        return {
            field: col,
            headerName: col,
            flex: 1,
            renderCell: (prm) => {
                if (col !== 'Data') {
                    return (
                        <Box sx={{ display: "flex", flex: 1, flexDirection: "row", justifyContent: "space-around", alignContent: "center", backgroundColor: isOddIndex ? "rgba(30, 30, 66, 0.84)" : "transparent", height: "stretch" }}>
                            <Typography variant={"body1"}>{prm.value["qt"]}</Typography>
                            <Typography variant={"body1"}>{formatMoney(prm.value["total"], "decimal")}</Typography>
                        </Box>
                    )
                }
                return <Typography variant={"body1"}>{prm.value}</Typography>
            },
            renderHeader: (params) => {
                let totalizacao = rows.total.find(value => value.item === params.field)

                if (col !== "Data") {
                    return (
                        <Box sx={{ display: "flex", flex: 1, flexDirection: "column", backgroundColor: isOddIndex ? "rgba(30, 30, 66, 0.84)" : "transparent" }}>
                            <Typography variant={"caption"} sx={{ flex: 1 }} textAlign={"center"}>{col}</Typography>
                            <Box sx={{ display: "flex", flex: 1, flexDirection: "row", justifyContent: "space-around", alignContent: "center" }}>
                                <Typography variant={"caption"}>Qtde: {totalizacao['qt']}</Typography>
                                <Typography variant={"caption"}>Total: {formatMoney(totalizacao['total'], "decimal")}</Typography>
                            </Box>
                        </Box>
                    )
                }
                return <Typography variant={"button"}>{col}</Typography>
            },
        }
    })
}

const DetalhamentoVendasPedido = (props: CardResumoProps) => {
    const { rows_itens_mov_detalhe } = props.movState
    return (
        <Card>
            <StripedDataGrid
                disableRowSelectionOnClick
                rows={rows_itens_mov_detalhe.values}
                columns={getCollumn(rows_itens_mov_detalhe)}
                getRowId={row => row._id}
                density={'compact'}
                style={{ fontSize: '0.875rem' }}
                hideFooterPagination={true}
                hideFooter={true}
                filterMode="client"
                loading={rows_itens_mov_detalhe.loading}

            />
            <Typography textAlign={"right"} variant="h3" color="success">Total: {formatMoney(rows_itens_mov_detalhe.total.map(value => value.total).reduce((a, b) => a + b, 0))}</Typography>
        </Card>
    )
}

const DetalhamentoAvarias = (props: CardResumoProps) => {
    const { rows_itens_avaria_detalhe } = props.movState
    return (
        <Card>
            <StripedDataGrid
                disableRowSelectionOnClick
                rows={rows_itens_avaria_detalhe.values}
                columns={getCollumn(rows_itens_avaria_detalhe)}
                getRowId={row => row._id}
                density={'compact'}
                style={{ fontSize: '0.875rem' }}
                hideFooterPagination={true}
                hideFooter={true}
                filterMode="client"
                loading={rows_itens_avaria_detalhe.loading}
            />
            <Typography textAlign={"right"} variant="h3" color="success">Total: {formatMoney(rows_itens_avaria_detalhe.total.map(value => value.total).reduce((a, b) => a + b, 0))}</Typography>
        </Card>
    )
}

const DetalhamentoCompras = (props: CardResumoProps) => {
    const { rows_itens_compras_detalhe } = props.movState
    return (
        <Card>
            <StripedDataGrid
                disableRowSelectionOnClick
                rows={rows_itens_compras_detalhe.values}
                columns={getCollumn(rows_itens_compras_detalhe)}
                getRowId={row => row._id}
                density={'compact'}
                style={{ fontSize: '0.875rem' }}
                hideFooterPagination={true}
                hideFooter={true}
                filterMode="client"
                loading={rows_itens_compras_detalhe.loading}
            />
            <Typography textAlign={"right"} variant="h3" color="success">Total: {formatMoney(rows_itens_compras_detalhe.total.map(value => value.total).reduce((a, b) => a + b, 0))}</Typography>
        </Card>
    )
}

const ShellResumoMovItens = (props: CardResumoProps) => {
    const { tabAba, filtro } = props.movState
    const { setTabAba, readMovItensPeriodo, readQtItensMovFuncByPeriodo } = props.movActions

    const handleChangeTab = (event: React.SyntheticEvent, value: any) => {
        setTabAba(value);
        switch (value) {
            case 3:
                handleReadEstoque();
                break;
            case 4:
                readQtItensMovFuncByPeriodo(props.filtro);
                break;

            default:
                readMovItensPeriodo(props.filtro, getDescAba(value));
                break;
        }
    }

    return (
        <Box sx={{ display: "flex", flex: 1, flexDirection: "column", pt: 1, width: "100%" }}>
            <ToolbarModal
                elevation={3}
                handleClose={() => props.movActions.setShowModalResumoItens(false)}
                title={"Listagem de movimentações de itens no período de: " + formatData(props.filtro.dtIni!) + " Até " + formatData(props.filtro.dtFim!)}
            />
            <Container sx={{ mt: 1 }}>
                <Box sx={{ display: "flex", flex: 1, borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs value={tabAba} onChange={handleChangeTab} variant="scrollable" scrollButtons="auto" allowScrollButtonsMobile aria-label="Itens Movimentado">
                        <Tab label={<Typography variant="subtitle1">Vendas/Pedidos</Typography>} {...a11yProps(0)} />
                        <Tab label={<Typography variant="subtitle1">Avarias</Typography>} {...a11yProps(1)} />
                        <Tab label={<Typography variant="subtitle1">Compras</Typography>} {...a11yProps(2)} />
                        <Tab label={<Typography variant="subtitle1">Estoque</Typography>} {...a11yProps(3)} />
                        <Tab label={<Typography variant="subtitle1">Comissão</Typography>} {...a11yProps(4)} />
                    </Tabs>
                </Box>
                <TabPanel value={tabAba} index={0}  >
                    <DetalhamentoVendasPedido {...props} />
                </TabPanel>
                <TabPanel value={tabAba} index={1}  >
                    <DetalhamentoAvarias {...props} />
                </TabPanel>
                <TabPanel value={tabAba} index={2}  >
                    <DetalhamentoCompras {...props} />
                </TabPanel>
                <TabPanel value={tabAba} index={3}  >
                    <EstoqueView />
                </TabPanel>
                <TabPanel value={tabAba} index={4}  >
                    <ShellComissao {...props} />
                </TabPanel>

            </Container>

        </Box>
    )

}

// Assuming the return type is RowItensMovDetalheFunc[], import it if available
// If not, fallback to any[]
import type { RowItensMovDetalheFunc } from "../../movimentacoes/mov.model";

const getCollumnComissao = (row: RowItensMovDetalheFunc): GridColDef[] => {
    return row.rows.coluna.map((value, idx) => {

        return {
            field: value,
            headerName: value,
            headerAlign:"center",
            renderCell: (prm) => prm.value,
            flex: 1
        }
    })
}
const ShellComissao = (props: CardResumoProps) => {
    const { movActions, movState } = props
    const { loadingRows, rows_itens_mov_qt_funcionario } = movState
    const [rowComissao, setRowComissao] = useState<{ aba: number, row: RowItensMovDetalheFunc }>({ aba: 0, row: { _id: "", funcionario: "", rows: { coluna: [], loading: false, total: [], values: [] } } });

    console.log("rowComissao", rowComissao);
    useEffect(() => {
        if (rows_itens_mov_qt_funcionario.length > 0)
            setRowComissao({ aba: 0, row: rows_itens_mov_qt_funcionario[0] })
    }, [rows_itens_mov_qt_funcionario.length])

    const handleChange = (event: React.SyntheticEvent, value: any) => {
        setRowComissao({ aba: value, row: rows_itens_mov_qt_funcionario[value] })
    }

    const FooterComponent = () => {
        let totalComissao = 0;
        return (
            <Box sx={{padding:1}}>
                <Box sx={{ display: "flex", flex: 1, flexDirection: "row" }}>
                    {rowComissao.row.rows.coluna.map((value: any, idx) => {
                        if (value !== "Data") {
                            let qt = 0;
                            let comissao = 0;
                            let totalFind = rowComissao.row.rows.total.find(t => t.item === value)
                            console.log("findTotal", totalFind)
                            if(totalFind){
                                qt = totalFind.qt;
                                comissao = totalFind.comissao;
                                totalComissao += totalFind.comissao;
                            }
                            return (
                                <Box key={idx} sx={{ display: "flex", flex: 1, flexDirection: "column", justifyContent:"center",pl:2 }}>
                                    <Typography variant="body2" flex={1}>{qt}</Typography>
                                    <Typography variant="body2" flex={1}>{formatMoney(comissao)}</Typography>
                                </Box>
                            )
                        }
                        return <Typography key={idx} variant="subtitle1" flex={1}>Total</Typography>
                    })}
                </Box>
                <Typography variant="h6" textAlign={"right"}>Comissão {formatMoney(totalComissao)} </Typography>
            </Box>

        )
    }

    return (
        <Box>
            <Box sx={{ display: "flex", flex: 1, borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={rowComissao?.aba} onChange={handleChange} variant="scrollable" scrollButtons="auto" allowScrollButtonsMobile aria-label="Comissão do funcionario">
                    {rows_itens_mov_qt_funcionario.map((row, idx) => (
                        <Tab key={idx} label={<Typography variant="subtitle1">{row.funcionario}</Typography>} {...a11yProps(idx)} />
                    ))}

                </Tabs>
            </Box>
            <TabPanel value={rowComissao.aba} index={rowComissao.aba}  >
                <Card>
                    <StripedDataGrid
                        disableRowSelectionOnClick
                        rows={rowComissao?.row.rows.values}
                        columns={getCollumnComissao(rowComissao.row)}
                        getRowId={row => row._id}
                        density={'compact'}
                        style={{ fontSize: '0.875rem' }}
                        hideFooterPagination={true}
                        hideFooter={false}
                        filterMode="client"
                        loading={loadingRows}
                        slots={{
                            footer: FooterComponent
                        }}

                    />
                </Card>
            </TabPanel>
        </Box>
    )
}

const mapStateToCardResumoMovProps = (state: ApplicationState) => ({
    movState: state.movState,
})

const mapDispatchToCardResumoMovProps = (dispatch: Dispatch) => ({
    movActions: bindActionCreators({ ...movController.reducer.actions }, dispatch)
})

export default connect(mapStateToCardResumoMovProps, mapDispatchToCardResumoMovProps)(CardResumoMov);